module.exports = __webpack_public_path__ + "static/signin-854474bbba1c524fe89f462894cb8392.png";